import { API_URL } from '../../../app-config/constants';
import { DownloadableFile } from '../../../types/DownloadableFile';
import { post } from '../request';

const BASE_PATH = `${API_URL}/messages`;

export type ExportParams = {
    from: string; // LocalDate
    to: string; // LocalDate
    format: 'csv' | 'excel';
};

export function triggerDownload(params: ExportParams) {
    return post<DownloadableFile>(`${BASE_PATH}/peer-feedback-export`, {
        getData: { ...params },
    });
}
